import '../social_content_previous_comments_view.js.coffee';# Added by Script 
import '../social_content_parent_post_view.js.coffee'
Monitoring.Views ||= {}

class Monitoring.Views.InstagramMessageCurrentMessageView extends Monitoring.Views.SocialContentPreviousCommentsView

  buildQuery: =>
    @searchQuery = new Monitoring.Models.SearchQuery({}, { use_defaults: false })
    @searchQuery.addContextKind('ig_message')
    @addContextLimit()
    @searchQuery.addContentId(@socialContent.externalId())
